import { find, identity, isEqual, memoize, size, sortBy } from 'lodash/fp';

import constants from '../../../../../../ahm-constants';

const {
  PRODUCT: {
    CHOOSABLE_60_TEETH_EYES,
    CHOOSABLE_60_TEETH_EYES_MUSCLE_BONE,
    CHOOSABLE_60_TEETH_EYES_WELLBEING,
    CHOOSABLE_60_TEETH_EYES_WELLBEING_MUSCLE_BONE,
    CHOOSABLE_60_TEETH_MUSCLE_BONE,
    CHOOSABLE_60_TEETH_WELLBEING,
    CHOOSABLE_60_TEETH_WELLBEING_MUSCLE_BONE,
  },
  PRODUCT_LIMIT_CATEGORY: { MUSCLE_BONE, OPTICAL, WELLBEING },
} = constants;

const PRODUCT_BUNDLES_MAPPING = [
  { bundles: [OPTICAL], product: CHOOSABLE_60_TEETH_EYES },
  { bundles: [MUSCLE_BONE, OPTICAL], product: CHOOSABLE_60_TEETH_EYES_MUSCLE_BONE },
  { bundles: [OPTICAL, WELLBEING], product: CHOOSABLE_60_TEETH_EYES_WELLBEING },
  {
    bundles: [MUSCLE_BONE, OPTICAL, WELLBEING],
    product: CHOOSABLE_60_TEETH_EYES_WELLBEING_MUSCLE_BONE,
  },
  { bundles: [MUSCLE_BONE], product: CHOOSABLE_60_TEETH_MUSCLE_BONE },
  { bundles: [WELLBEING], product: CHOOSABLE_60_TEETH_WELLBEING },
  {
    bundles: [MUSCLE_BONE, WELLBEING],
    product: CHOOSABLE_60_TEETH_WELLBEING_MUSCLE_BONE,
  },
];

export const determineProductIdFromBundles = memoize((selectedBundles) => {
  if (size(selectedBundles) === 0) {
    return null;
  }

  const match = find(({ bundles }) => isEqual(bundles, sortBy(identity, selectedBundles)), PRODUCT_BUNDLES_MAPPING);
  return match?.product;
});

export const determineBundlesFromProductId = memoize((productId) => {
  const match = find(({ product }) => product === productId, PRODUCT_BUNDLES_MAPPING);
  return match?.bundles ?? [];
});
